"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dcMiniCalendarAgendaController = /** @class */ (function () {
    function dcMiniCalendarAgendaController($rootScope, UserService, $state, CalendarModel, EntitiesModel) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.UserService = UserService;
        this.$state = $state;
        this.CalendarModel = CalendarModel;
        this.EntitiesModel = EntitiesModel;
        this.prev = this.agendaPrev.bind(this);
        this.next = this.agendaNext.bind(this);
        this.currentUser = UserService.getCurrentUser();
        this.isDriveSession = EntitiesModel.isDriveSession;
        this.isCourse = EntitiesModel.isCourse;
        this.isEvent = EntitiesModel.isEvent;
        this.isRTO = EntitiesModel.isRTO;
        this.currentAgendaIndex = 0;
        this.loading = true;
        this.viewDriveSession = this.viewDriveSession.bind(this);
        this.shouldShowLabel = this.shouldShowLabel.bind(this);
        this.setAgenda = this.setAgenda.bind(this);
        this.$rootScope.$watch("CalendarModel.getAgenda", function () {
            _this.setAgenda();
        });
        this.$rootScope.$on("ADMIN_CALENDAR_AGENDA_UPDATED", this.setAgenda);
        this.$rootScope.$on("STUDENT_CALENDAR_AGENDA_UPDATED", this.setAgenda);
        this.$rootScope.$on("CALENDAR_LOADING", function () {
            _this.loading = true;
        });
    }
    dcMiniCalendarAgendaController.prototype.shouldShowLabel = function (item) {
        if (this.currentUser.role.type !== "student") {
            return true;
        }
        return item.label.name !== "OPEN SESSION";
    };
    dcMiniCalendarAgendaController.prototype.viewDriveSession = function (item) {
        if (this.currentUser.role.type === "student") {
            return this.$state.go("drivecoach.student.drives.create", {
                id: item.id,
            });
        }
        return this.$state.go("drivecoach.admin.drives.edit", { id: item.id });
    };
    dcMiniCalendarAgendaController.prototype.setAgenda = function () {
        this.loading = false;
        if (this.paging === false) {
            this.agendaItems = this.CalendarModel.getAgendaData().list;
        }
        else {
            this.currentAgendaIndex = 0;
            this.agendaItems = this.CalendarModel.getAgenda();
            this.totalAgendaItems = this.CalendarModel.getAgendaData().total;
            this.agendaCollection = this.CalendarModel.getAgendaData().all;
        }
    };
    dcMiniCalendarAgendaController.prototype.agendaPrev = function () {
        if (this.currentAgendaIndex === 0) {
            return;
        }
        this.agendaItems = this.agendaCollection[this.currentAgendaIndex - 1];
        this.currentAgendaIndex = this.currentAgendaIndex - 1;
    };
    dcMiniCalendarAgendaController.prototype.agendaNext = function () {
        //console.log(this.currentAgendaIndex , this.totalAgendaItems.length)
        if (this.currentAgendaIndex === this.agendaCollection.length) {
            return;
        }
        this.agendaItems = this.agendaCollection[this.currentAgendaIndex + 1];
        this.currentAgendaIndex = this.currentAgendaIndex + 1;
    };
    return dcMiniCalendarAgendaController;
}());
dcMiniCalendarAgendaController.$inject = [
    "$rootScope",
    "UserService",
    "$state",
    "CalendarModel",
    "EntitiesModel",
];
exports.default = dcMiniCalendarAgendaController;
